// extracted by mini-css-extract-plugin
export var footer = "_ng-5";
export var fulfillmentInput = "_ng-0";
export var shipDateInput = "_ng-1";
export var shipmentModal = "_ng-2";
export var shipmentModalContent = "_ng-3";
export var tableContainer = "_ng-4";